import { Component, OnInit , Input } from '@angular/core';

@Component({
  selector: 'gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
})
export class GalleryComponent implements OnInit {
  @Input() imageList: Array<{ id, src }>
  demoData = []
  selectedImage:string = null // "https://picsum.photos/id/1002/4312/2868"
  constructor() {
    this.demoData = new Array(15).fill(1).map(t => `https://picsum.photos/id/${Math.floor(Math.random() * 100)}/${Math.floor(Math.random() * 10)}00/${Math.floor(Math.random() * 10)}00`);
  }

  ngOnInit() { }

  previewImage(item) {
    this.selectedImage = item
  }
  deleteImage(props) {
    this.imageList = this.imageList.filter(t => t.id !== props.id)
  }
}
